export default {
	default: 'Default',
	contact: 'Contact Info',
	faq: 'FAQ',
	news: 'News',
	project: 'Posillico Inc Project',
	product: 'Materials Product',
	video: 'Video',
	career: 'Career',
	team: 'Team',
};
